<template>
    <div>
        <b-list-group>
            <b-card>
                    <div v-if="!watchers.length" class="alert alert-info">No hay observadores asignados</div>
                    <div v-else class="card-text">
                        <b-list-group-item v-for="(watcher, i) in watchers" :key="i" class="d-flex justify-content-between align-items-center">
                            {{i+1}}. {{watcher.user.name}} 
                            <b-badge variant="primary" pill>{{watcher.user.email}}</b-badge>  
                        </b-list-group-item>
                    </div>
            </b-card>
            
        </b-list-group>
    </div>
</template>

<script>
export default {
    props: {
        watchers: {
            type: Array,
            default: []
        }
    },
}
</script>
    